<div class="left-panel"></div>
<div class="right-panel">
  <img src="/assets/images/shell.png" class="logo" />
  <div class="login-form" (keydown)="enterSubmit($event)">
    <h4 class="right-h4">Welcome to DSCAL Software</h4>

    @if (!isRedirectAuth) {
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput [formControl]="emailAddress" id="email-input" />
        @if (emailAddress.invalid) {
          <mat-error>{{ getEmailAddressErrorMessage() }}</mat-error>
        }
      </mat-form-field>
      @if (showPasswordField) {
        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input
            matInput
            [formControl]="password"
            [type]="hidePassword ? 'password' : 'text'"
            id="password-input"
            />
            <button
              mat-icon-button
              matSuffix
              (click)="hidePassword = !hidePassword"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hidePassword"
              id="hide-password-btn"
              >
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (password.invalid) {
              <mat-error> {{ getPasswordErrorMessage() }}</mat-error>
            }
          </mat-form-field>
        }
      }

      <button
        class="btn btn-primary btn-big login-btn"
        id="login-btn"
        type="button"
        (click)="onButtonClick()"
      [disabled]="
        !isRedirectAuth && (emailAddress.invalid || (showPasswordField && password.invalid))
      "
        >
        {{ buttonLabel }}
      </button>
      <div class="actions">
        <ng-content></ng-content>
      </div>
    </div>
    <span class="spacer"></span>
    <footer class="footer">{{ footerText }}</footer>
  </div>
